import { Form, Input, Switch } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";

type Props = {};

const LevelForm = (props: Props) => {
  const { t } = useTranslation();
  return (
    <div>
      <Form.Item
        label={t("form:name")}
        name={"name"}
        rules={[{ required: true, message: t("error:name_is_required") }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label={t("form:operator_access")}
        name={"operator_access"}
        rules={[
          { required: false, message: t("error:operator_access_is_required") },
        ]}
      >
        <Switch />
      </Form.Item>
    </div>
  );
};

export default LevelForm;
